import { alpha, Theme } from '@mui/material/styles';

/** Véu e sombra do bloco que a voz está lendo. Os dois painéis usam a mesma marca. */
export function greeningReadingShade(theme: Theme, active: boolean) {
  if (!active) return {};
  return {
    borderRadius: 1,
    bgcolor: alpha(theme.palette.success.main, 0.16),
    boxShadow: `0 0 0 2px ${alpha(theme.palette.success.main, 0.45)}, 0 8px 18px ${alpha(theme.palette.success.main, 0.28)}`,
  };
}

/** Índice do trecho em que a leitura está, pelo quanto do texto já foi falado. */
export function indexAtRatio(parts: string[], ratio: number): number {
  if (!parts.length) return -1;
  const weights = parts.map((part) => Math.max(part.trim().length, 1));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  let cursor = Math.min(0.999, Math.max(0, ratio)) * total;
  for (let index = 0; index < weights.length; index += 1) {
    cursor -= weights[index];
    if (cursor <= 0) return index;
  }
  return weights.length - 1;
}

/** Leva o bloco lido ao centro, como na análise. */
export function scrollReadingTarget(id: string) {
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
}
